<template>
  <div class="customer-service-container">
    <!-- 单个图标按钮 - 始终固定在右下角，根据状态切换图标 -->
    <div class="customer-service-minimized" @click="toggleExpanded">
      <div v-if="!isExpanded" class="service-icon">
        <img :src="iconContactUs" alt="联系我们" />
      </div>
      <div v-else>
        <i class="fas fa-xmark"></i>
      </div>
    </div>

    <!-- 展开状态内容 - 显示在图标按钮上方 -->
    <div v-if="isExpanded" class="customer-service-expanded">
      <div class="service-content">
        <div class="content-wrapper">
          <!-- 左侧联系选项 -->
          <div class="contact-options">
            <div
              class="contact-option"
              :class="{ active: activeTab === 'contact' }"
              @click="switchTab('contact')"
            >
              <i class="fas fa-search contact-icon"></i>
              <span>联系我们</span>
            </div>
            <!-- <div
              class="contact-option"
              :class="{ active: activeTab === 'video' }"
              @click="switchTab('video')"
            >
              <i class="fas fa-play contact-icon"></i>
              <span>官方视频号</span>
            </div>
            <div
              class="contact-option"
              :class="{ active: activeTab === 'douyin' }"
              @click="switchTab('douyin')"
            >
              <i class="fas fa-music contact-icon"></i>
              <span>官方抖音号</span>
            </div> -->
          </div>

          <!-- 右侧二维码 -->
          <div class="qrcode-section">
            <div class="qrcode-container">
              <img
                v-if="activeTab === 'contact'"
                :src="contactQrCodeUrl"
                alt="微信二维码"
                class="qrcode-image"
              />
              <div v-else-if="activeTab === 'video'" class="qrcode-placeholder">
                <div class="qrcode-placeholder-content">
                  <i class="fas fa-play-circle"></i>
                  <span>视频号二维码</span>
                </div>
              </div>
              <div
                v-else-if="activeTab === 'douyin'"
                class="qrcode-placeholder"
              >
                <div class="qrcode-placeholder-content">
                  <i class="fas fa-music"></i>
                  <span>抖音号二维码</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import iconContactUs from "@/assets/icon_contact_us.svg";

// 控制展开/收起状态
const isExpanded = ref(false);

// 当前激活的标签页
const activeTab = ref("contact");

// 切换展开/收起
const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};

// 切换标签页
const switchTab = (tab: string) => {
  activeTab.value = tab;
};
const contactQrCodeUrl = 'https://nexbankapi-go-logo.oss-cn-shanghai.aliyuncs.com/contact/contact101.jpg';

</script>

<style scoped>
/* 容器基础样式 */
.customer-service-container {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
}

/* 单个图标按钮 - 始终固定在右下角 */
.customer-service-minimized {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: var(--primary);
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
  z-index: 2;
  position: relative;
}

.customer-service-minimized:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.service-icon {
  font-size: 24px;
}

/* 展开状态样式 - 显示在图标按钮上方 */
.customer-service-expanded {
  width: 400px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideIn 0.3s ease;
  position: absolute;
  bottom: 80px;
  right: 0;
  z-index: 1;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 展开状态内容 */
.service-content {
  padding: 20px;
  position: relative;
}

/* 内容包装器 - 实现左右布局 */
.content-wrapper {
  display: flex;
  gap: 20px;
}

/* 左侧联系选项 */
.contact-options {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.contact-option {
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
  padding: 10px 15px;
}

.contact-option:hover {
  background-color: #f9fafb;
}

/* 激活状态 */
.contact-option.active {
  background-color: #f0f9ff;
}

.contact-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f9ff;
  color: var(--primary);
  border-radius: 50%;
  margin-right: 12px;
  font-size: 16px;
}

.contact-option.active .contact-icon {
  background-color: var(--primary);
  color: white;
}

/* 右侧二维码部分 */
.qrcode-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qrcode-container {
  width: 160px;
  height: 160px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 二维码占位符 */
.qrcode-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  border: 1px dashed #e5e7eb;
  position: relative;
}

.qrcode-placeholder-content {
  text-align: center;
  color: #6b7280;
}

.qrcode-placeholder-content i {
  font-size: 48px;
  margin-bottom: 10px;
  color: #d1d5db;
}

.qrcode-placeholder-content span {
  font-size: 14px;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 关闭按钮 - 纯粹的图标按钮 */
.close-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
  font-size: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.close-button:hover {
  background-color: #e5e7eb;
  color: #374151;
  transform: scale(1.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .customer-service-container {
    right: 10px;
    bottom: 10px;
  }

  .customer-service-expanded {
    width: 260px;
  }

  .service-content {
    padding: 16px;
  }

  .qrcode-container {
    width: 140px;
    height: 140px;
  }
}
</style>
